import Vue from 'vue'
import VueRouter, { Route } from 'vue-router'
import { AppService } from "@/service/app.service"
import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to: any) {

    if (to.name != "Locations") {
      const appElement = document.getElementById('app');
      if (appElement != null) {
        appElement.scrollIntoView();
      }
    }
  }
})

// List of routes that require an intermediate page
const routesThatRequireFinalDetailsEligibleScreen = [
    'MatchHeadstartReferral',
    'MatchHeadstartAndHSGSRPLikelyReferral',
    'MatchHSGSRPLikelyReferral',
    'MatchNone',
    'MatchGSRPReferral',
    'MatchGSRPLikelyReferral',
    'MatchNoneAndGSRPReferral',
    'MatchNoneAndGSRPLikelyReferral',
    'MatchHSAndGSRPReferral',
    'MatchNoneCDC',
    'MatchNoneCDCLikelyAndGSRPReferral',

]

// eslint-disable-next-line @typescript-eslint/no-explicit-any
router.beforeEach((to: Route, from: Route, next: any) => {
  if (routesThatRequireFinalDetailsEligibleScreen.includes(to.name as string) && !from.name?.includes('FinalDetailsEligibility')) {
    next({ path: 'FinalDetailsEligibility', query: { redirect: to.fullPath } })
  }
  else {
    next()
  }
})
// Redirect all pages to welcome screen if app data does not exist
// eslint-disable-next-line
router.beforeEach((to: Route, from: Route, next: any) => {
  if (to.meta.needAppData && !new AppService().getAppData()) {
    // no app data stored in cookie, navigate to the 'Welcome' page
    next('/')
  }
  else {
    next()
  }
})

export default router
